import Temp from '@/courier/Temp'

export default class JAndTExpress extends Temp {

    static CODE = 'JNT';

    static NAME_TYPE = {
      'EAST-BKK_GBKK': 1, 
      'EAST-BKK_C': 2, 
      'EAST-BKK_N-S': 3,
      'EAST-BKK_NE': 4,
      'SAMUT-PRAKAN_GBKK': 5,
      'SAMUT-PRAKAN_C-N-NE-S': 6,
      'WEST-BKK_GBKK': 7,
      'WEST-BKK_C-NE': 8,
      'WEST-BKK_CE-N-S': 9,
      'NONTHABURI-GBKK_SPK-AYA': 10,
      'NONTHABURI-GBKK_CMI-PLK-RYG-KKN-NMA-SNI-SKA': 11,
      'NONTHABURI-UPC_SPK-AYA': 12,
      'NONTHABURI-UPC_CMI-PLK-RYG-KKN-NMA-SNI-SKA': 13,
      'PATHUM-THANI-GBKK_SPK-AYA': 14,
      'PATHUM-THANI-GBKK_CMI-SKA': 15,
      'PATHUM-THANI-GBKK_PLK-RYG-KKN-NMA-SNI': 16,
      'PATHUM-THANI-UPC_SPK-AYA': 17,
      'PATHUM-THANI-UPC_CMI-SNI-SKA': 18,
      'PATHUM-THANI-UPC_PLK-RYG-KKN-NMA': 19,
      'NAKHON-PATHOM_SPK-AYA': 20,
      'NAKHON-PATHOM_RYG-KKN-NMA': 21,
      'NAKHON-PATHOM_CMI-PLK-SNI-SKA': 22,
      'KORAT_SPK-AYA-PLK-RYG-KKN-NMA': 23,
      'KORAT_CMI-SNI': 24,
      'KORAT_SKA': 25,
      'CHIANG-MAI_SPK-AYA': 26,
      'CHIANG-MAI_RYG-KKN-NMA': 27,
      'CHIANG-MAI_SNI-SKA': 28,
      'CHIANG-MAI_CMI-PLK': 29,
      'KHON-KAEN_SPK-GBKK-AYA-GBKK': 30,
      'KHON-KAEN_SPK-UPC-AYA-UPC-CMI-PLK-RYG-KKN-NMA': 31,
      'KHON-KAEN_SNI-SKA': 32,
      'CHONBURI_GBKK': 33,
      'CHONBURI_SAME-PROVINCE': 34,
      'CHONBURI_C-N-NE-S': 35,
      'CHONBURI-RAYONG_GBKK': 36,
      'CHONBURI-RAYONG_SAME-PROVINCE': 37,
      'CHONBURI-RAYONG_C': 38,
      'CHONBURI-RAYONG_N-NE-S': 39,
      'CHONBURI-UPC_GBKK-C': 40,
      'CHONBURI-UPC_SAME-PROVINCE': 41,
      'CHONBURI-UPC_N-NE-S': 42,
      'SOUTH_GBKK': 43,
      'SOUTH_C-N-NE-S': 44,
      'SOUTH_SAME-PROVINCE': 45
    }

    constructor() {
        super( JAndTExpress.CODE );
    }

    async getZone( item ){
        let type , from , to
        let cross_price = 0
        let remote_area = 0
        let travel_surcharge = 0

        remote_area = super.checkRemoteArea(Number(item.toPostcode))
        travel_surcharge = super.checkTravelSurcharge(Number(item.toPostcode))

        if (travel_surcharge) {
          if (item.weight > 20000) {
            travel_surcharge = 200
          } else if (item.weight > 7000) {
            travel_surcharge = 100
          } else {
            travel_surcharge = 30
          }
        }

        from = { province: item.province.from, district: item.district.from }
        to = { province: item.province.to, district: item.district.to } 

        type = await this.checkRateType({ from, to })

        return {
          rate_type: type,
          rate_remote_area: remote_area,
          travel_surcharge: travel_surcharge,
          cross_price: cross_price,
        }
    }

    async filterZone() {
      const url = this._VUE.$API_URL
      let courierPostcodeDetails = JSON.parse(localStorage.getItem('courier_postcode'))
      let cpd = 0
      if (courierPostcodeDetails) {
        cpd = courierPostcodeDetails.version
      } else {
        cpd = 0
      }

      const res = await this._VUE.$http.get(`${url}/shop/${cpd}`, 
      {
        headers: {
          Token: localStorage.getItem("access_token")
        }
      })

      if (res.status !== 200) {
        return []
      }

      const { district, province } = res.data.data

      const zone = await this.getZoneName(
        { district, province },
        { district, province }
      )

      if (!zone) {
        return []
      }

      const originZone = zone.split('_')[0].trim()

      const filter = Object.keys(JAndTExpress.NAME_TYPE).filter((z) => z.includes(originZone))

      return filter
    }

    async checkRateType(item) {
      let from = { ...item.from }
      let to = { ...item.to }
      const zone = await this.getZoneName(from, to)

      const zones = this.getAvaliableZones()
      let type = zones[zone] ? zones[zone] : null

      return type
    }

    async getZoneName(from, to) {
      const zoneArea = await super.getCourierZone(JAndTExpress.CODE)
      const coverageZone = zoneArea.data.coverageZone

      let zone = ''

      from.province = from.province.replace('จ.', '')
      to.province = to.province.replace('จ.', '')
      from.district = from.district.replace('เขต', '')
      to.district = to.district.replace('เขต', '')

      if (coverageZone.hasOwnProperty(`${from.province}_${from.district}`) && coverageZone[`${from.province}_${from.district}`].hasOwnProperty(`${to.province}_${to.district}`)) {
        zone = coverageZone[`${from.province}_${from.district}`][`${to.province}_${to.district}`].zone
      } else if (coverageZone.hasOwnProperty(`${from.province}_${from.district}`) && coverageZone[`${from.province}_${from.district}`].hasOwnProperty(`${to.province}_*`)) {
        zone = coverageZone[`${from.province}_${from.district}`][`${to.province}_*`].zone
      } else if (coverageZone.hasOwnProperty(`${from.province}_*`) && coverageZone[`${from.province}_*`].hasOwnProperty(`${to.province}_${to.district}`)) {
        zone = coverageZone[`${from.province}_*`][`${to.province}_${to.district}`].zone
      } else if (coverageZone.hasOwnProperty(`${from.province}_*`) && coverageZone[`${from.province}_*`].hasOwnProperty(`${to.province}_*`)) {
        zone = coverageZone[`${from.province}_*`][`${to.province}_*`].zone
      }

      return zone
    }

    checkWeight( courierRates , item , validate ){
        item.index = courierRates.findIndex(rate => {
            return item.weight >= rate.min && item.weight <= rate.max
        })

        return super.checkRules( item , validate );
    }

    checkDimension( dimensionCourier , item , validate ){
        return super.checkCourierDimension( dimensionCourier , item , validate );
    }

    async checkRemoteAreaByCorrectorDest(addressRemote, option){
        return new Promise((resolve) => {
          super.getArea([addressRemote], ['JNTP', 'JNTD'], option).then((res) => {
            let weight = option.weight;
            if (weight < ((option.price && option.price.selectedTier) ? option.price.selectedTier.max : 0)) {
              weight = option.price.selectedTier.max
            }
            let returnRate = {
              isRemote: res.data[option.pickup_type]?(res.data[option.pickup_type].is_remote?50:0):0,
              isTravelArea: 0,
              isIsland: res.data[option.pickup_type]?(res.data[option.pickup_type].is_island?30:0):0
            };
              
            if (res.data && res.data[option.pickup_type] && res.data[option.pickup_type].is_tourist) {
              if (weight > 20000) {
                returnRate.isTravelArea = 200;
              } else if (weight > 7000) {
                returnRate.isTravelArea = 100;
              } else {
                returnRate.isTravelArea = 30;
              }
            }
            
            resolve(returnRate);
          });
        });
    }

    getAvaliableZones() {
      return JAndTExpress.NAME_TYPE
    }

    mapAvaliableZoneName(key) {
      const map = {
        'EAST-BKK_GBKK': 'ต้นทาง: กรุงเทพมหานคร (ฝั่งตะวันออก) ปลายทาง: กรุงเทพมหานคร', 
        'EAST-BKK_C': 'ต้นทาง: กรุงเทพมหานคร (ฝั่งตะวันออก) ปลายทาง: ภาคกลาง', 
        'EAST-BKK_N-S': 'ต้นทาง: กรุงเทพมหานคร (ฝั่งตะวันออก) ปลายทาง: ภาคเหนือ/ใต้',
        'EAST-BKK_NE': 'ต้นทาง: กรุงเทพมหานคร (ฝั่งตะวันออก) ปลายทาง: ภาคตะวันออกเฉียงเหนือ',
        'SAMUT-PRAKAN_GBKK': 'ต้นทาง: สมุทรปราการ/ฉะเชิงเทรา ปลายทาง: กรุงเทพมหานคร',
        'SAMUT-PRAKAN_C-N-NE-S': 'ต้นทาง: สมุทรปราการ/ฉะเชิงเทรา ปลายทาง: กาคกลาง/เหนือ/ตะวันออกเฉียงเหนือ/ใต้',
        'WEST-BKK_GBKK': 'ต้นทาง: กรุงเทพมหานคร (ฝั่งตะวันตก) ปลายทาง: กรุงเทพมหานคร',
        'WEST-BKK_C-NE': 'ต้นทาง: กรุงเทพมหานคร (ฝั่งตะวันตก) ปลายทาง: ภาคกลาง/ตะวันออกเฉียงเหนือ',
        'WEST-BKK_CE-N-S': 'ต้นทาง: กรุงเทพมหานคร (ฝั่งตะวันตก) ปลายทาง: ภากลาง/เหนือ/ใต้',
        'NONTHABURI-GBKK_SPK-AYA': 'ต้นทาง: NONTHABURI-GBKK ปลายทาง: SPK/AYA',
        'NONTHABURI-GBKK_CMI-PLK-RYG-KKN-NMA-SNI-SKA': 'ต้นทาง: NONTHABURI-GBKK ปลายทาง: CMI/PLK/RYG/KKN/NMA/SNI/SKA',
        'NONTHABURI-UPC_SPK-AYA': 'ต้นทาง: NONTHABURI-UPC ปลายทาง: SPK/AYA',
        'NONTHABURI-UPC_CMI-PLK-RYG-KKN-NMA-SNI-SKA': 'ต้นทาง: NONTHABURI-UPC ปลายทาง: CMI/PLK/RYG/KKN/NMA/SNI/SKA',
        'PATHUM-THANI-GBKK_SPK-AYA': 'ต้นทาง: ปทุมธานี ปลายทาง: SPK/AYA',
        'PATHUM-THANI-GBKK_CMI-SKA': 'ต้นทาง: ปทุมธานี ปลายทาง: CMI/SKA',
        'PATHUM-THANI-GBKK_PLK-RYG-KKN-NMA-SNI': 'ต้นทาง: ปทุมธานี ปลายทาง: PLK/RYG/KKN/NMA/SNI',
        'PATHUM-THANI-UPC_SPK-AYA': 'ต้นทาง: พระนครศรีอยุธยา/สระบุรี ปลายทาง: SPK/AYA',
        'PATHUM-THANI-UPC_CMI-SNI-SKA': 'ต้นทาง: พระนครศรีอยุธยา/สระบุรี ปลายทาง: CMI/SNI/SKA',
        'PATHUM-THANI-UPC_PLK-RYG-KKN-NMA': 'ต้นทาง: พระนครศรีอยุธยา/สระบุรี ปลายทาง: PLK/RYG/KKN/NMA',
        'NAKHON-PATHOM_SPK-AYA': 'ต้นทาง: NAKHON-PATHOM ปลายทาง: SPK/AYA',
        'NAKHON-PATHOM_RYG-KKN-NMA': 'ต้นทาง: NAKHON-PATHOM ปลายทาง: RYG/KKN/NMA',
        'NAKHON-PATHOM_CMI-PLK-SNI-SKA': 'ต้นทาง: NAKHON-PATHOM ปลายทาง: CMI/PLK/SNI/SKA',
        'KORAT_SPK-AYA-PLK-RYG-KKN-NMA': 'ต้นทาง: KORAT ปลายทาง: SPK/AYA/PLK/RYG/KKN/NMA',
        'KORAT_CMI-SNI': 'ต้นทาง: KORAT ปลายทาง: CMI/SNI',
        'KORAT_SKA': 'ต้นทาง: KORAT ปลายทาง: SKA',
        'CHIANG-MAI_SPK-AYA': 'ต้นทาง: CHIANG-MAI ปลายทาง: SPK/AYA',
        'CHIANG-MAI_RYG-KKN-NMA': 'ต้นทาง: CHIANG-MAI ปลายทาง: RYG/KKN/NMA',
        'CHIANG-MAI_SNI-SKA': 'ต้นทาง: CHIANG-MAI ปลายทาง: SNI/SKA',
        'CHIANG-MAI_CMI-PLK': 'ต้นทาง: CHIANG-MAI ปลายทาง: CMI/PLK',
        'KHON-KAEN_SPK-GBKK-AYA-GBKK': 'ต้นทาง: KHON-KAEN ปลายทาง: SPK-GBKK/AYA-GBKK',
        'KHON-KAEN_SPK-UPC-AYA-UPC-CMI-PLK-RYG-KKN-NMA': 'ต้นทาง: KHON-KAEN ปลายทาง: SPK-UPC/AYA-UPC/CMI/PLK/RYG/KKN/NMA',
        'KHON-KAEN_SNI-SKA': 'ต้นทาง: KHON-KAEN ปลายทาง: SNI/SKA',
        'CHONBURI_GBKK': 'ต้นทาง: ชลบุรี ปลายทาง: กรุงเทพมหานคร',
        'CHONBURI_SAME-PROVINCE': 'ต้นทาง: ชลบุรี ปลายทาง: จังหวัดเดียวกัน',
        'CHONBURI_C-N-NE-S': 'ต้นทาง: ชลบุรี ปลายทาง: ภาคกลาง/เหนือ/ตะวันออกเฉียงเหนือ/ใต้',
        'CHONBURI-RAYONG_GBKK': 'ต้นทาง: ระยอง ปลายทาง: กรุงเทพมหานคร',
        'CHONBURI-RAYONG_SAME-PROVINCE': 'ต้นทาง: ระยอง ปลายทาง: จังหวัดเดียวกัน',
        'CHONBURI-RAYONG_C': 'ต้นทาง: ระยอง ปลายทาง: ภาคกลาง',
        'CHONBURI-RAYONG_N-NE-S': 'ต้นทาง: ระยอง ปลายทาง: ภาคเหนือ/ตะวันออกเฉียงเหนือ/ใต้',
        'CHONBURI-UPC_GBKK-C': 'ต้นทาง: จันทบุรี/ตราด ปลายทาง: กรุงเทพมหานคร/ภาคกลาง',
        'CHONBURI-UPC_SAME-PROVINCE': 'ต้นทาง: จันทบุรี/ตราด ปลายทาง: จังหวัดเดียวกัน',
        'CHONBURI-UPC_N-NE-S': 'ต้นทาง: จันทบุรี/ตราด ปลายทาง: ภาคเหนือ/ตะวันออกเฉียงเหนือ/ใต้',
        'SOUTH_GBKK': 'ต้นทาง: SOUTH ปลายทาง: กรุงเทพมหานคร',
        'SOUTH_C-N-NE-S': 'ต้นทาง: SOUTH ปลายทาง: ภาคกลาง/เหนือ/ตะวันออกเฉียงเหนือ/ใต้',
        'SOUTH_SAME-PROVINCE': 'ต้นทาง: SOUTH ปลายทาง: จังหวัดเดียวกัน'
      }

      return map[key]
    }

}